import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import ContactStack from "../ContactPage/ContactPage";
import ClientSection from '../About/ClientSection/ClientSection';
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import whatsappImg from "../../assets/whatsapp.png";
import "./Team.css";

// Import local images for the first few members
import img1 from "../../assets/Team/Benny.png";
import img2 from "../../assets/Team/Bharani.png";
import img3 from "../../assets/Team/Areevu.png";
import img4 from "../../assets/Team/Shabeer.png";
import img5 from "../../assets/Team/Arun.png";
import img6 from "../../assets/Team/Ramji.png";
import img7 from "../../assets/Team/Dinesh.png";
import img8 from "../../assets/Team/Vignesh.png";
import img9 from "../../assets/Team/Neelavathi.png";
import img10 from "../../assets/Team/Divakar.png";
import img11 from "../../assets/Team/Hari.png";
import img12 from "../../assets/Team/Akshaya.png";

import joinIllustration from "../../assets/join_team_illustration.png";

const teamMembers = [
    { name: "Benny Abraham R", role: "CEO", img: img1 },
    { name: "Bharanitharan M", role: "Production Head", img: img2 },
    { name: "Arevazhagun V C", role: "Digital Head", img: img3 },
    { name: "Mohammad Shabeer Khan S", role: "Creative Head", img: img4 },
    { name: "Arun Raj B", role: "Marketing Head", img: img5 },
    { name: "Ramji B", role: "Project Manager", img: img6 },
    { name: "Dinesh Kumar S", role: "Senior Graphic Designer", img: img7 },
    { name: "Vignesh R", role: "Video Editor", img: img8 },
    { name: "Neelavathi S", role: "UI/UX & Graphic Designer", img: img9 },
    { name: "Diwakar S", role: "UI/UX Designer", img: img10 },
    { name: "Hariharan S", role: "Web Developer", img: img11 },
    { name: "Akhshaya M", role: "Social Media Executive", img: img12 },
];


const Team = () => {
    const [showContact, setShowContact] = useState(false);
    const [selectedPosition, setSelectedPosition] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const formRef = useRef(null);

    const scrollToApply = () => {
        const element = document.getElementById("apply-section");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(formRef.current);

        // Add identifier
        formData.append("form_type", "Ascent Team Application Form");

        try {
            const response = await fetch(
                "https://formsubmit.co/admin@ascentbw.com", // ❌ removed /ajax
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (response.ok) {
                alert("Thank you! Your application has been submitted.");
                formRef.current.reset();
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("Network error. Please try again later.");
        }
    };


    return (
        <div className="team-page-wrapper">
            <Navbar />


                    <ClientSection />
                    {/*   <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1 className="team-hero-title">The Team Powering<br />Ascent Brandworks</h1>
                    </motion.div> */}
              
            {/* Meet the Minds Section */}
            <section className="team-grid-section">
                <Container>
                    <div className="section-header1 text-center mb-5">
                        <div className="d-flex justify-content-center">
                            <span className="badge-team">THE ASCENT TEAM</span>
                        </div>
                        <h2 className="section-title mt-4">Meet the Minds Behind Ascent</h2>
                        <p className="section-subtitle mx-auto mt-3">
                            Our team brings together strategy, creativity, and technology to build brands that stand out.
                            Each member contributes unique expertise to deliver meaningful and impactful solutions.
                        </p>
                    </div>

                    <Row className="gy-5">
                        {teamMembers.map((member, index) => (
                            <Col key={index} lg={4} md={6} sm={12}>
                                <motion.div
                                    className="team-card"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ delay: (index % 3) * 0.1, duration: 0.6 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="team-img-wrapper">
                                        <img
                                            src={member.img}
                                            alt={member.name}
                                           className="team-img grayscale"
                                        />
                                        {/* Colored line matching design */}
                                        <div className="card-accent-line"></div>
                                    </div>
                                    <div className="team-member-info">
                                        <h4 className="member-name">{member.name}</h4>
                                        <p className="member-role">{member.role}</p>
                                    </div>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Join the Team Section */}
            <section className="join-team-section">
                <Container>
                    <div className="join-team-box shadow-sm">
                        <Row className="align-items-center g-5">
                            <Col lg={6}>
                                <div className="join-content">
                                    <h2 className="join-title">Join the Team <br /> Behind Ascent</h2>
                                    <p className="join-desc mt-4">
                                        Join a team of passionate creators working together to shape meaningful brand experiences.
                                    </p>
                                    <div className="join-actions mt-5">
                                        <button className="btn-apply-now" onClick={scrollToApply}>Apply For Job</button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} className="text-center">
                                <motion.img
                                    initial={{ opacity: 0, scale: 0.95 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.8 }}
                                    src={joinIllustration}
                                    alt="Illustration"
                                    className="join-illustration img-fluid"
                                />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

            {/* Career Section */}
           {/*  <section className="career-section" id="career-section">
                <Container>
                    <div className="section-header1 text-center mb-5">
                        <div className="d-flex justify-content-center">
                            <span className="badge-team">CAREERS AT ASCENT</span>
                        </div>
                        <h2 className="section-title mt-4">Build Your Career with Ascent</h2>
                        <p className="section-subtitle mx-auto mt-3">
                            Join a team of passionate creators, strategists, and innovators working together to build impactful brands and digital experiences.
                        </p>
                    </div>

                    <div className="positions-list">
                        {openPositions.map((pos, index) => (
                            <motion.div
                                key={index}
                                className="position-card"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <div className="pos-info">
                                    <h3 className="pos-title">{pos.title}</h3>
                                    <p className="pos-desc">{pos.description}</p>
                                    <span className="pos-details">{pos.type}</span>
                                </div>
                                <button className="btn-apply-small" onClick={scrollToApply}>Apply</button>
                            </motion.div>
                        ))}
                    </div>
                </Container>
            </section> */}

            {/* Application Form Section */}
            <section className="apply-form-section" id="apply-section">
                <Container>
                    <div className="apply-container text-center">
                        <h2 className="apply-title">Apply to Join Our Team</h2>
                        <p className="apply-subtitle mt-4 mb-5">
                            Share a few details about yourself and the role you're interested in. Our team will review your application and get back to you shortly.
                        </p>

                        <motion.div
                            className="apply-card shadow-lg mx-auto"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <form ref={formRef} onSubmit={handleSubmit} className="team-form" encType="multipart/form-data">
                                <Row className="g-4">
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Name</label>
                                        <input type="text" name="name" className="form-control-custom" placeholder="Your Name" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Email Address</label>
                                        <input type="email" name="email" className="form-control-custom" placeholder="Email Address" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Phone Number</label>
                                        <input type="tel" name="phone" className="form-control-custom" placeholder="Phone Number" required />
                                    </Col>
                                    <Col md={6} xs={12} className="text-start">
                                        <label className="form-label-custom">Position Applied For</label>
                                        <select 
                                            name="position" 
                                            className="form-control-custom" 
                                            required 
                                            value={selectedPosition}
                                            onChange={(e) => setSelectedPosition(e.target.value)}
                                        >
                                            <option value="" disabled>Select Position</option>
                                            <option value="Digital Marketing Intern">Digital Marketing Intern</option>
                                            <option value="Video Editor Intern">Video Editor Intern</option>
                                            <option value="Full Stack Developer">Full Stack Developer</option>
                                            <option value="Graphic Designer">Graphic Designer</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </Col>

                                    {selectedPosition === "Other" && (
                                        <Col md={6} xs={12} className="text-start">
                                            <label className="form-label-custom">Specify Position</label>
                                            <input 
                                                type="text" 
                                                name="other_position" 
                                                className="form-control-custom" 
                                                placeholder="Enter position name" 
                                                required 
                                            />
                                        </Col>
                                    )}
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Portfolio / LinkedIn URL</label>
                                        <input type="url" name="portfolio" className="form-control-custom" placeholder="https://..." required />
                                    </Col>
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Upload CV / Resume</label>
                                        <input
                                            type="file"
                                            name="attachment"
                                            className="form-control-custom resume-upload"
                                            accept=".pdf,.doc,.docx"
                                            required
                                        />

                                        <small className="text-muted mt-1 d-block">Accepted formats: PDF, DOC, DOCX (Max 5MB)</small>
                                    </Col>
                                    <Col xs={12} className="text-start">
                                        <label className="form-label-custom">Why do you want to join Ascent?</label>
                                        <textarea name="message" className="form-control-custom" rows="4" placeholder="Tell us about yourself..." required></textarea>
                                    </Col>

                                    {/* Hidden FormSubmit config */}
                                    <input type="hidden" name="_captcha" value="false" />
                                    <input type="hidden" name="_template" value="table" />
                                    <input
                                        type="hidden"
                                        name="_subject"
                                        value="New Job Application - Ascent Team Page"
                                    />

                                    <Col xs={12}>
                                        <button type="submit" className="btn-submit-team">Submit Application</button>
                                    </Col>
                                </Row>
                            </form>
                        </motion.div>
                    </div>
                </Container>
            </section>

            <Footer onContactClick={() => setShowContact(true)} />

            <AnimatePresence>
                {showContact && (
                    <ContactStack onClose={() => setShowContact(false)} />
                )}
            </AnimatePresence>

            <ScrollToTop />

            {/* Fixed WhatsApp Icon */}
            <a
                href="https://wa.me/7540001028"
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "20px",
                    zIndex: 9999,
                    cursor: "pointer",
                }}
            >
                <img
                    src={whatsappImg}
                    alt="WhatsApp Chat"
                    style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                    }}
                />
            </a>
        </div>
    );
};

export default Team;
